import { API_URL, getCachedSessionId } from 'src/services/common';

import { fetchTripResponseData } from './interfaces/fetchTripDataResponse';
import { api } from '../../../../util/axios-instance';

export const fetchTripData = async (params: {
  orderBy: string;
  orderDirection: string;
  page: string;
  pageSize: string;
  projectId: string;
  search: string;
}): Promise<fetchTripResponseData | undefined> => {
  const { projectId, page, pageSize, orderBy, orderDirection, search } = params;

  const response = await api.get<fetchTripResponseData>(
    `${API_URL}/v1/project/${projectId}/external/trip?page=${page}&limit=${pageSize}&orderBy=${orderBy}&orderDirection=${orderDirection}&search=${search}`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};
